<template>
  <div class="el-popper industry-dropdown" :style="{ minWidth: '210px' }">
    <div>
      <el-input v-model="query" placeholder="搜索">
        <i slot="suffix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>
    <el-scrollbar v-if="computedList.length != 0" tag="ul" ref="scrollbar" wrap-class="search-scroll_wrap">
      <!-- <li class="industry-item" @click="onSelectAll()" :class="checkAll() ? 'selected' : ''">全部</li> -->
      <li v-for="(item, index) in computedList" :key='index' @click="onSelect(item.value)" :class="[check(item.value) ? 'industry-item selected' : 'industry-item',{'hq-industry-item':HQ}]">{{item.label}}</li>
    </el-scrollbar>
    <div style="font-size: 14px;color: #555; margin-top:10px" v-if="computedList.length === 0">
      没有搜索匹配项
    </div>
  </div>
</template>

<script type="text/babel">
import ElScrollbar from 'element-ui/lib/scrollbar';
export default {
  props: {
    value: {
      default: []
    },
    options: {
      default() {
        return [];
      }
    },
    noAll: {
      default: false
    }
  },
  data() {
    return {
      minWidth: '',
      query: ''
    };
  },

  computed: {
    computedList() {
      return this.options.filter(item => {
        return (
          item.label.toLowerCase().indexOf(this.query.toLowerCase()) !== -1
        );
      });
    }
  },

  methods: {
    onSelect(value) {
      let options = this.value;
      if (
        (value == 'all' && options.indexOf('all') != -1) ||
        (value == 'none' && options.indexOf('none') != -1)
      ) {
        this.$emit('input', []);
        return;
      }
      if (value == 'all' && options.indexOf('all') == -1) {
        this.$emit('input', ['all']);
        return;
      }
      if (value == 'none' && options.indexOf('none') == -1) {
        this.$emit('input', ['none']);
        return;
      }
      if (options.indexOf('all') != -1 || options.indexOf('none') != -1) {
        this.$emit('input', [value]);
        return;
      }
      let index = options.indexOf(value);
      if (index == -1) {
        options.push(value);
      } else {
        options.splice(index, 1);
      }
      if(this.noAll) {
        this.$emit('input', options);
        return;
      }
      let hasNone =
        this.options.filter(item => {
          return item.value == 'none';
        }).length == 1;
      if (hasNone) {
        if (options.length == this.options.length - 2) {
          this.$emit('input', ['all']);
        } else {
          this.$emit('input', options);
        }
      } else {
        if (options.length == this.options.length - 1) {
          this.$emit('input', ['all']);
        } else {
          this.$emit('input', options);
        }
      }
    },
    onSelectAll() {
      this.$emit('input', []);
    },
    checkAll() {
      if (this.value.length === 0) {
        return true;
      }
    },
    check(val) {
      if (this.value.indexOf(val) != -1) {
        return true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.industry-dropdown {
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  margin: 5px 0;
  padding: 10px;
  z-index: 3000 !important;
}

.industry-item {
  font-size: 14px;
  padding: 0 20px;
  padding-left: 4px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #5a5e66;
  height: 34px;
  line-height: 34px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
}

.industry-item.selected {
  color: var(--theme-color);
}
.hq-industry-item.selected {
  color: #337ab7;
}
.industry-item.selected:after {
  position: absolute;
  right: 10px;
  font-family: element-icons;
  content: '\E611';
  font-size: 12px;
  font-weight: 700;
  -webkit-font-smoothing: antialiased;
}

.industry-item.hover,
.industry-item:hover {
  background: #f5f7fa;
}
</style>




// WEBPACK FOOTER //
// src/components/clickSelect/searchSelect.vue